import { type AxiosInstance } from "axios";
import { handleMutationError } from "@/features/dmManagement/api/handleApiError";

interface DownloadUrlResponse {
  downloadUrl: string;
}

/**
 * 指定された発注の宛先リスト原本ファイルをダウンロードする。
 * @param apiClient - axios インスタンス
 * @param id - 発注ID
 * @returns ダウンロードURLを新しいタブで開く
 */
export const GetAddressListDownloadAPI = async (
  apiClient: AxiosInstance,
  id: number
): Promise<void> => {
  const url = `/dm/orders/${id}/address-list/download/`;

  try {
    const response = await apiClient.get<DownloadUrlResponse>(url);
    window.open(response.data.downloadUrl, "_blank");
  } catch (error) {
    handleMutationError(error);
  }
};
